import { render, staticRenderFns } from "./BaseTile.vue?vue&type=template&id=2c0f68dc&scoped=true&"
import script from "./BaseTile.vue?vue&type=script&lang=js&"
export * from "./BaseTile.vue?vue&type=script&lang=js&"
import style0 from "./BaseTile.vue?vue&type=style&index=0&id=2c0f68dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f68dc",
  null
  
)

export default component.exports